import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterLabelsApplicationValueEnum } from "services/api/openapi"

export const LabelsApplicationFilter = SimpleAutocompleteFactory<TransactionFilterLabelsApplicationValueEnum>({
  automaticLabel: "Automatic",
  manualLabel: "Manual",
})

export default LabelsApplicationFilter
